import { useFlags } from 'launchdarkly-react-client-sdk';
import { useStore } from 'components/Store';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import {
  INVENTORY_PRODUCTS_LIST_V2,
  INVENTORY_PRODUCTS_LIST_V2_BY_ORG
} from 'constants/inventoryServiceV2Flags';

const useInventoryProductsV2Flag = () => {
  const { state } = useStore();
  const orgId = state?.organization?.id;
  const flags = useFlags();

  return featureFlagRenderItem(
    flags[INVENTORY_PRODUCTS_LIST_V2],
    flags[INVENTORY_PRODUCTS_LIST_V2_BY_ORG],
    orgId
  );
};

export default useInventoryProductsV2Flag;
